import Cookies from "js-cookie";

import API from "./API";
import TenantAPI from "./TenantAPI";
import { Query } from "../../types/GlobalInterfaces";

export default class NotificationsAPI {
  static async fetchComments(Query: Query) {
    return API._bearerRequest(
      "put",
      `/tenant/notifications/fetch`,
      { Query },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async readNotifications(notificationsInfo: {
    NotificationIDs: string[];
    RecordComments: { [key: string]: number };
  }) {
    return API._bearerRequest(
      "put",
      `/tenant/notifications/update-many`,
      { notifications: notificationsInfo },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }
}
